/* FleetPro Filters Module v1.0.0 - fp-loadmore.js
   "Load more" pagination for collection + search. Converts Athens' numbered pagination into one
   button that APPENDS the next page via FacetFiltersForm.renderPage(qs,null,true,true), then rebuilds
   the button after each AJAX grid replace (single page-lifetime MutationObserver on #ProductGridContainer).
   Premium cards (card-product.liquid) are server-rendered each fetch, so no inject crutch.
   Loaded (deferred) by sections/fp-collection.liquid & fp-search-heading.liquid.
   Debug: set window.__fpFiltersDebug = true for warnings. See FP_FILTERS_MODULE.md. Marker: fp-loadmore */
(function () {
  var LABEL = (window.fpLoadMoreText || 'Load more');
  var fp = (window.fpFilters = window.fpFilters || { version: '1.0.0', loaded: {} });
  fp.loaded.loadmore = '1.0.0';
  function warn() {
    if (window.__fpFiltersDebug && window.console && console.warn)
      console.warn.apply(console, ['[fp-filters/loadmore]'].concat([].slice.call(arguments)));
  }

  function setLoading(btn, on) {
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function convert(container) {
    var pag = container.querySelector('.pagination');
    if (!pag || pag.dataset.fpLm) return; // none, or already processed
    pag.dataset.fpLm = '1';
    pag.style.display = 'none';

    // Drop any button left over from a previous render of this container.
    var stale = container.querySelector('.fp-loadmore-wrap');
    if (stale) stale.remove();

    var next = pag.querySelector('.page-number-next');
    if (!next) return; // last page - no button

    var wrap = document.createElement('div');
    wrap.className = 'fp-loadmore-wrap';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fp-loadmore';
    btn.textContent = LABEL;
    btn.setAttribute('aria-busy', 'false');
    wrap.appendChild(btn);
    pag.parentNode.insertBefore(wrap, pag.nextSibling);

    btn.addEventListener('click', function () {
      var href = next.getAttribute('href') || '';
      if (!href) return;
      var qs = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
      setLoading(btn, true);
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
        // 4th arg = appendResults: keep current products, add the next page below.
        try {
          FacetFiltersForm.renderPage(qs, null, true, true);
        } catch (e) {
          warn('renderPage threw - falling back to navigation', e);
          window.location.href = href;
          return;
        }
        // A successful append replaces #ProductGridContainer, so this button is removed and
        // rebuilt. If that has not happened, the request stalled - restore the button so the
        // user can retry instead of staring at a dead control.
        setTimeout(function () {
          if (btn.isConnected && btn.classList.contains('is-loading')) {
            warn('append did not complete - restoring button');
            setLoading(btn, false);
          }
        }, 8000);
      } else {
        warn('FacetFiltersForm unavailable - full-page fallback');
        window.location.href = href; // graceful fallback if facets.js absent
      }
    });
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    convert(container);
    // facets.js replaces #ProductGridContainer innerHTML on every append/sort/filter,
    // wiping our button + flag - rebuild it each time.
    new MutationObserver(function () { convert(container); })
      .observe(container, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
